module.exports = __webpack_public_path__ + "img/arrow-bar-up.2463601d.svg";